import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowLeft, RotateCcw, Send } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useI18n } from "@/lib/i18n";
import { useContent } from "@/lib/content";

export default function PaymentFailurePage() {
  const { lang } = useI18n();
  const { content } = useContent();
  const [params] = useSearchParams();
  const reason = params.get("reason") || params.get("error") || params.get("message");
  const c = content?.contacts || {};

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-24 sm:pt-32 pb-16 sm:pb-24">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="text-center"
          >
            <div className="inline-flex size-20 rounded-full bg-destructive/15 items-center justify-center mb-6">
              <XCircle className="size-12 text-destructive" strokeWidth={2.5} />
            </div>
            <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight mb-4" data-testid="payment-failure-title">
              {lang === "ru" ? "Оплата не прошла" : "Payment failed"}
            </h1>
            <p className="text-base text-muted-foreground mb-6 leading-relaxed">
              {lang === "ru"
                ? "Платёж не был выполнен. Деньги с карты не списаны. Вы можете попробовать ещё раз или связаться с нами."
                : "The payment was not completed. No funds were charged. You can try again or contact us."}
            </p>
            {reason && (
              <div className="inline-block max-w-full p-4 rounded-2xl border border-destructive/30 bg-destructive/10 text-sm text-destructive mb-8 break-all" data-testid="payment-failure-reason">
                {lang === "ru" ? "Причина: " : "Reason: "}{reason}
              </div>
            )}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 mb-10">
              <Link to="/payment" className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-full bg-foreground text-background font-semibold text-sm hover:translate-y-[-2px] transition-transform" data-testid="payment-failure-retry">
                <RotateCcw className="size-4" />
                {lang === "ru" ? "Попробовать снова" : "Try again"}
              </Link>
              <Link to="/" className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-full border border-border text-foreground font-semibold text-sm hover:bg-muted">
                <ArrowLeft className="size-4" />
                {lang === "ru" ? "На главную" : "Back home"}
              </Link>
            </div>
            {c.telegram_link && (
              <p className="text-sm text-muted-foreground inline-flex items-center gap-2">
                <Send className="size-4" />
                {lang === "ru" ? "Нужна помощь:" : "Need help:"}
                <a className="text-foreground underline underline-offset-2" href={c.telegram_link} target="_blank" rel="noopener noreferrer">Telegram</a>
              </p>
            )}
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
